import { render, staticRenderFns } from "./ExpertCenter.vue?vue&type=template&id=15113304&"
var script = {}
import style0 from "./ExpertCenter.vue?vue&type=style&index=0&id=15113304&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports